import axios from 'axios'

export default {
    get: () => axios.get(`/birthdays_gifts`),
    edit: formData => axios.post(`/birthdays_gifts/edit`, formData)
}